define('plugins/musicfavourite/ui/button-view',[
        'plugins/musicfavourite/events',
        './dom',
        './dialogs/dialog',
        './dialogs/upsell',
        'plugins/musicfavourite/ui/localisation',
        'plugins/musicfavourite/stats',
        './menu-view',
        './confirmationProfiles',
        'exports'],
    function(PubSub, DOM, Dialog, Upsell, Localisation, Stats, MenuView, confirmationProfiles, /* exports */ View) {

        'use strict';

        /**
         * Retrieve a localised string based on a translation key and category.
         * @private
         *
         * @param  {object} o        Object containing text
         * @param  {string} key      Key for translation text.
         * @param  {string} category Category for translation test (probably variant). Defaults to "standard".
         * @param  {string} lang     Language for lookup, defaults to "en-gb".
         * @return {string}          Translated text for key.
         */
        function getLocalisedString(o, key, category, lang) {
            var translatedKeys;

            if (!lang || !o[lang]) {
                lang = 'en-gb'; // default
            }

            translatedKeys = o[lang];

            category = category || 'standard';
            key = key || '';

            if (translatedKeys[category] && translatedKeys[category][key]) {
                return translatedKeys[category][key];
            }

            return lang !== 'en-gb' && getLocalisedString(key, category, 'en-gb') || key;
        }

        function checkElementHidden(el) {
            el = el[0] || el;
            return (el.offsetWidth > 0 && el.offsetHeight > 0) ? false : true;
        }

        function convertHTMLCode(text) {
            var map = {
                    '&agrave;': 'à',
                    '&aacute;': 'á',
                    '&egrave;': 'è',
                    '&eacute;': 'é',
                    '&igrave;': 'ì',
                    '&iacute;': 'í',
                    '&ograve;': 'ò',
                    '&oacute;': 'ó',
                    '&ugrave;': 'ù',
                    '&uacute;': 'ú',
                    '&Agrave;': 'À',
                    '&Aacute;': 'Á',
                    '&Egrave;': 'È',
                    '&Eacute;': 'É',
                    '&Igrave;': 'Ì',
                    '&Iacute;': 'Í',
                    '&Ograve;': 'Ò',
                    '&Oacute;': 'Ó',
                    '&Ugrave;': 'Ù',
                    '&Uacute;': 'Ú'
                },
                key;

            for (key in map) {
                text = text.replace(new RegExp(key, 'gim'), map[key]);
            }

            return text;
        }

        /**
         * Button view class.
         *
         * Controls users events and visible states on the button in the DOM by
         * listening to button controller events.
         */
        View = function(item) {
            // ===== contents of item =====
            // item [not used in View]
            // title
            // label
            // lang
            // variant
            // element
            // controller
            // parent
            // profile

            var self = this;

            self.item = item;

            self.item['localisationString'] = self.item.text.button;
            self.item['localisationStringDialog'] = self.item.text.dialog;
            self.item['localisationStringManagement'] = self.item.text.management;
            self.item['localisationStringConfirmation'] = self.item.text.confirmation;
            self.item['localisationStringOptions'] = self.item.text.options;

            self.item['button'] = DOM.findElement('.' + View.classes['button'], self.item['element']); // The actual button tag
            self.item['label'] = DOM.findElement('.' + View.classes['label'], self.item['button']);
            self.item['label-display'] = DOM.findElement('.' + View.classes['label-display'], self.item['button']);
            self.item['label-text'] = DOM.findElement('.' + View.classes['label-text'], self.item['label-display']);
            self.item['label-action'] = DOM.findElement('.' + View.classes['label-action'], self.item['label-display']);
            self.item['management-panel'] = DOM.findElement('.' + View.classes['management-panel'], self.item['element']);
            self.item['options-panel'] = DOM.findElement('.' + View.classes['options-panel'], self.item['element']);

            self.confirmationDialogElement = null;
            self.confirmationTimer = null;
            self.removeConfirmationTimer = null;
            self.confirmationEventsBound = false;

            if (self.item.feedbackMode) {
                if (!self.item.fillsContainer) console.warn("Music Add Button: Feedback mode does not work well without 'fills-container' set to true");
                MenuView.initialise(self.item['element'], self.item.cardSelector, self.item.title, self.item['localisationStringOptions'], self.item.lang);
                self.item['feedback-overlay'] = MenuView.getFeedbackOverlay();
                self.bindFeedbackEvents();
            }
            self.bindEvents();
            self.bindManagementEvents();

            self.setVariantLabel();

            self.item.controller.subscribe('added', function() {
                self.added();
            });

            self.item.controller.subscribe('removed', function() {
                self.removed();
            });

            self.item.controller.subscribe('busy', function() {
                self.busy();
            });

            self.item.controller.subscribe('busy.adding', function() {
                self.busyAdding();
            });

            self.item.controller.subscribe('busy.removing', function() {
                self.busyRemoving();
            });

            self.item.controller.subscribe('busy.addingfeedback', function() {
                self.busyAddingFeedback();
            });

            self.item.controller.subscribe('busy.removingfeedback', function() {
                self.busyRemovingFeedback();
            });

            self.item.controller.subscribe('finished', function(button) {
                self.finished(button);
            });

            self.item.controller.subscribe('finished.added', function() {
                self.added();
                self.showAddedConfirmation();
            });

            self.item.controller.subscribe('finished.removed', function() {
                self.removed();
            });

            self.item.controller.subscribe('finished.feedbackadded', function() {
                self.feedbackAdded();
            });

            self.item.controller.subscribe('finished.feedbackremoved', function() {
                self.feedbackRemoved();
            });

            self.item.controller.subscribe('finished.failedsendingfeedback', function(idUnavailable) {
                self.failedToSendFeedback(idUnavailable);
            });

            self.item.controller.subscribe('confirmation.dismissed', function() {
                self.confirmationDismissed(self.item['button']);
            });


            // TODO: refactor failedAdding function to be cleaner and not include error dialog
            self.item.controller.subscribe('finished.limited', function() {
                self.failedAdding(false); //false means it won't show the dialog overlay displaying an error message.
            });


            self.item.controller.subscribe('finished.cancelled.cancelledAdding', function() {
                self.failedAdding(false); //false means it won't show the dialog overlay displaying an error message.
            });

            self.item.controller.subscribe('finished.failed', function() {
                self.failed();
            });

            self.item.controller.subscribe('finished.failed.failedAdding', function(idUnavailable) {
                self.failedAdding(true, idUnavailable);
            });

            self.item.controller.subscribe('finished.failed.failedRemoving', function(idUnavailable) {
                self.failedRemoving(idUnavailable);
            });

            if (bbcRequireMap !== null && bbcRequireMap !== undefined &&
                bbcRequireMap['memodule'] !== false && bbcRequireMap['memodule'] !== undefined) {
                require(['memodule/main'],
                    function(meRemove) {
                        meRemove.subscribe('finished', function() {
                            self.item.controller.isAddedAsync();
                        });
                    }
                );
            }
            if (self.item.defaultAdded) {
                self.added();
            } else {
                self.removed();
            } // Little hackish but updates the label if not favourited to the js version of the labels

            self.item.controller.isAddedAsync();

            self.setFakeButton();
            self.setManagementPanelTranslations();

            return { // Need to check if this is still required as may have been used for old .setItem in the API - 30/05/2013
                'setLabel': function(elem, textKey, variant, html) {
                    self.setLabel(elem, textKey, variant, html);
                },
                'setTitle': function(key) {
                    self.title(self.getLabelText(key));
                }
            };
        };

        View.prototype = {
            'setFakeButton': function() {
                // This is for screen readers to alert he update to the button, in conjuction with resetFocus()
                // May want to refactor to a single button to focus against to save inserting html for each rendered button.
                var id = DOM.getAttr(this.item['button'], 'id') + '_fake',
                    button = [
                        '<button id="', id, '" class="', View.classes['hidden'], '" role="presentation" aria-hidden="true" style="width:1px;height:1px;opacity:0;" tabindex="-1">'
                    ].join('');

                DOM.append(this.item['element'], button);

                this.item['fakeButton'] = DOM.findElement('#' + id);
            },

            'setManagementPanelTranslations': function() {
                if (this.item.managementMode) {
                    var translations = this.getManagementPanelTranslations(this.item.lang),
                        panelActionLabel = DOM.findElement('.' + View.classes['managementPanelLabel'], this.item['management-panel']),
                        confirmButtonLabel = DOM.findElement('.' + View.classes['confirmActionButton'] + ' .' + View.classes['actionButtonLabel'], this.item['management-panel']),
                        cancelButtonLabel = DOM.findElement('.' + View.classes['cancelActionButton'] + ' .' + View.classes['actionButtonLabel'], this.item['management-panel']);

                    DOM.setText(panelActionLabel, translations.actionLabelText);
                    DOM.setText(confirmButtonLabel, translations.confirmActionText);
                    DOM.setText(cancelButtonLabel, translations.cancelActionText);
                }
            },

            'setVariantLabel': function() {
                this.setLabel(this.item['label-text'], 'addToFavourites', this.item['variant'], true);
            },

            'busy': function() {
                DOM.removeClass(this.item['button'], View.classes['remove']);
                DOM.addClass(this.item['button'], View.classes['busy']);
                DOM.setAttr(this.item['button'], 'aria-busy', true);
            },

            'busyAdding': function() {
                this.setLabel(this.item['label'], 'adding', 'standard', false);
                this.setLabel(this.item['label-text'], 'adding', this.item['variant'], true);
            },

            'busyRemoving': function() {
                this.setLabel(this.item['label'], 'removing', 'standard', false);
                this.setLabel(this.item['label-text'], 'removing', this.item['variant'], true);
            },

            'busyAddingFeedback': function() {
                var overlay = this.item['feedback-overlay'];
                DOM.addClass(overlay, View.classes['active']);
                DOM.addClass(overlay, View.classes['toFront']);
                DOM.addClass(overlay, View.classes['busy']);
            },

            'busyRemovingFeedback': function() {
                var overlay = this.item['feedback-overlay'];
                DOM.addClass(overlay, View.classes['busy']);
            },

            'feedbackAdded': function() {
                var overlay = this.item['feedback-overlay'];
                DOM.removeClass(overlay, View.classes['busy']);
            },

            'feedbackRemoved': function() {
                var overlay = this.item['feedback-overlay'];
                DOM.removeClass(overlay, View.classes['active']);
                DOM.removeClass(overlay, View.classes['toFront']);
                DOM.removeClass(overlay, View.classes['busy']);
                this.hideOptionsPanel();
            },

            'failed': function() {
                DOM.addClass(this.item['button'], View.classes['error']);
            },

            'failedToSendFeedback': function(idUnavailable) {
                var overlay = this.item['feedback-overlay'];
                DOM.removeClass(overlay, View.classes['active']);
                DOM.removeClass(overlay, View.classes['busy']);
                DOM.removeClass(overlay, View.classes['toFront']);
                DOM.addClass(overlay, View.classes['hide']);
                this.hideOptionsPanel();

                var heading = Dialog.getLocalisedString('cannotSendFeedback', this.item.lang);
                idUnavailable ? this.showTechnicalDifficultiesDialog(heading) : this.showTryAgainDialog(heading);
            },

            'failedAdding': function(errored, idUnavailable) {
                DOM.removeClass(this.item['button'], View.classes['added']);
                this.setLabel(this.item['label'], 'addToFavourites', 'standard', false);
                this.setLabel(this.item['label-text'], 'addToFavourites', this.item['variant'], true);

                if (errored) {
                    if (this.item.item.typeReadable) {
                        var heading = Dialog.getLocalisedString('cannotAddFavouriteType', this.item.lang, {
                            'type': this.item.item.typeReadable
                        });
                    } else {
                        var heading = Dialog.getLocalisedString('cannotAddFavourite', this.item.lang);
                    }

                    idUnavailable ? this.showTechnicalDifficultiesDialog(heading) : this.showTryAgainDialog(heading);
                }
            },

            'failedRemoving': function(idUnavailable) {
                if (this.item.managementMode) {
                    DOM.addClass(this.item['button'], View.classes['remove']);
                } else {
                    DOM.addClass(this.item['button'], View.classes['added']);
                }

                this.setLabel(this.item['label'], 'addedToFavourites', 'standard', false);
                this.setLabel(this.item['label-text'], 'addedToFavourites', this.item['variant'], true);
                this.setLabel(this.item['label-action'], 'removeFromFavourites', this.item['variant'], true);

                if (this.item.item.typeReadable) {
                    var text = Dialog.getLocalisedString('cannotRemoveFavouriteType', this.item.lang, {
                        'type': this.item.item.typeReadable
                    });
                } else {
                    var text = Dialog.getLocalisedString('cannotRemoveFavourite', this.item.lang);
                }

                idUnavailable ? this.showTechnicalDifficultiesDialog(heading) : this.showTryAgainDialog(heading);
            },

            'showDialog': function(heading, text) {
                var h = [
                    '<h3 class="', Dialog.classes.heading, '">', heading, '</h3>',
                    '<p class="', Dialog.classes.text, '">', text, '</p>'
                ].join('');

                Dialog.setContent(h, function() {
                    Dialog.show();
                });

                this.setProperTabIndexOnDialog();
            },

            'showTryAgainDialog': function (heading) {
                this.showDialog(heading, Dialog.getLocalisedString('tryAgain', this.item.lang));
            },

            'showTechnicalDifficultiesDialog': function(heading) {
                this.showDialog(heading, Dialog.getLocalisedString('technicalDifficulties', this.item.lang));
            },

            'added': function() {
                DOM.removeClass(this.item['button'], View.classes['removed']);

                if (this.item.managementMode) {
                    DOM.addClass(this.item['button'], View.classes['remove']);
                } else {
                    DOM.addClass(this.item['button'], View.classes['added']);
                }

                this.setLabel(this.item['label'], 'removeFromFavouritesFullText', 'standard', false);
                this.setLabel(this.item['label-text'], 'addedToFavourites', this.item['variant'], true);
                this.setLabel(this.item['label-action'], 'removeFromFavourites', this.item['variant'], true);

                this.title(this.getLabelText('removeFromFavouritesFullText'));
            },

            'removed': function() {
                DOM.addClass(this.item['button'], View.classes['removed']);

                DOM.removeClass(this.item['button'], View.classes['added']);
                DOM.removeClass(this.item['button'], View.classes['remove']);
                DOM.removeClass(this.item['button'], View.classes['error']);

                this.setLabel(this.item['label'], 'addToFavourites', 'standard', false);
                this.setLabel(this.item['label-text'], 'addToFavourites', this.item['variant'], true);

                this.title(this.getLabelText('addToFavourites'));
            },

            'finished': function(button) {
                DOM.removeClass(this.item['button'], View.classes['error']);
                DOM.removeClass(this.item['button'], View.classes['busy']);
                DOM.setAttr(this.item['button'], 'aria-busy', false);

                // this.isButtonVisible(this.item['button']['0'].id) test if button is in vewport
                if (button === this.item && this.isButtonVisible(this.item['button']['0'].id)) {
                    //this.resetFocus();
                }
            },

            'confirmationDismissed': function(button) {
                //no-op
            },

            'title': function(text) {
                DOM.setAttr(this.item['button'], 'title', convertHTMLCode(text));
            },

            'bind': function(eventType, handler, elem, context) {
                DOM.off(elem, eventType);

                DOM.on(elem, eventType, function(e) {
                    //Commenting this out fixes PSP-3712
                    //if (eventType == 'click' || eventType == 'touchstart') { e.stop(); e.preventDefault(); }
                    handler.apply(context, arguments);
                });
            },

            'bindEvents': function() {
                var self = this,
                    eventType,
                    eventMap = {
                        click: this.click,
                        mouseenter: this.mouseEnter,
                        mouseleave: this.mouseLeave,
                        focus: this.focus,
                        setFocus: this.setFocus,
                        blur: this.blur,
                        touchstart: this.touchstart,
                        touchend: this.touchend,
                        ontouchstart: this.ontouchstart
                    };

                for (eventType in eventMap) {
                    self.bind(eventType, eventMap[eventType], self.item['button'][0], self);
                }
            },

            'bindManagementEvents': function() {
                var self = this;
                if (self.item.managementMode) {
                    var confirmButton = DOM.findElement('.' + View.classes['confirmActionButton'], self.item['management-panel'])[0];
                    var cancelButton = DOM.findElement('.' + View.classes['cancelActionButton'], self.item['management-panel'])[0];
                    self.bind('click', self.confirmAction, confirmButton, self);
                    self.bind('click', self.cancelAction, cancelButton, self);
                }
            },

            "bindFeedbackEvents": function() {
                var self = this;
                var optionsButton = DOM.findElement('.' + View.classes['optionsButton'], self.item['element'])[0];
                var feedbackButton = DOM.findElement('.' + View.classes['feedbackButton'], self.item['options-panel'])[0];
                var htmlElement = DOM.findElement('html', document)[0];
                self.bind('click', self.toggleOptionsPanel, optionsButton, self);
                self.bind('click', self.addFeedbackAction, feedbackButton, self);
                DOM.on(htmlElement, 'click', function(event) {
                    var target = event.target;
                    if (DOM.findClosestParent(target, '.p-f') !== self.item['element'] && !DOM.hasClass(self.item['feedback-overlay'], View.classes['active'])) {
                        self.hideOptionsPanel();
                    }
                });
                if (self.item['feedback-overlay']) {
                    var undoButton = DOM.findElement('.' + View.classes['undoButton'], self.item['feedback-overlay'])[0];
                    self.bind('click', self.removeFeedbackAction, undoButton, self);
                }
            },

            'resetFocus': function() {
                var self = this;

                setTimeout(function() {
                    if (!checkElementHidden(self.item['fakeButton'])) {
                        DOM.focus(self.item['fakeButton']);
                    } else {
                        self.setFocus();
                    }

                    DOM.addClass(self.item['button'], View.classes['refocus']);
                }, 50);
            },

            'focus': function() {
                var self = this;

                setTimeout(function() {
                    DOM.addClass(self.item['button'], View.classes['focus']);
                    DOM.setAttr(self.item['button'], 'aria-pressed', true);
                }, 40);
            },

            'setFocus': function() {
                var self = this,
                    toFocus = self.item['button'],
                    toFocusId = self.item['button']['0'].id,
                    visible = self.isButtonVisible(toFocusId);

                if (visible) {
                    setTimeout(function() {
                        if (checkElementHidden(toFocus)) {
                            toFocus = self.item['fakeButton'];
                        }
                        try {
                            DOM.focus(toFocus);
                        } catch (e) {
                            if (console && console.log) console.log('e', e);
                        }
                    }, 40);
                }
            },

            'blur': function() {
                if (DOM.hasClass(this.item['button'], View.classes['refocus'])) {
                    DOM.removeClass(this.item['button'], View.classes['refocus']);
                    DOM.removeClass(this.item['button'], View.classes['leave']);
                };
                if (DOM.hasClass(this.item['button'], View.classes['focus'])) {
                    DOM.removeClass(this.item['button'], View.classes['focus']);
                };
                DOM.removeClass(this.item['button'], View.classes['hover']);
                DOM.setAttr(this.item['button'], 'aria-pressed', false);

                if (!checkElementHidden(this.item['button'])) {
                    DOM.blur(this.item['button']);
                }
            },

            'testTouch': function() {
                var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

                return supportsTouch;
            },

            'click': function(e) {
                e.preventDefault();
                var self = this;

                if (self.item.managementMode && DOM.hasClass(this.item['button'], View.classes['remove'])) {
                    DOM.addClass(this.item['management-panel'], View.classes['active']);
                    DOM.hide(this.item['button']);
                } else if (self.item.controller.isSignedIn()) {
                    self.item.controller.toggleFavourite();
                } else {
                    Upsell.renderUpsellDialog(self.item);

                    var signInHandler = function() {
                        Dialog.hide(function() {
                            self.setSignedInChecker();
                        });
                    };

                    var registerHandler = function() {
                        Dialog.hide(function() {
                            self.setSignedInChecker();
                        });
                    };

                    self.bind('click', signInHandler, DOM.findElement('.' + View.classes['signInWrapper'] + ' .id4-cta-button')[0], self);
                    self.bind('click', registerHandler, DOM.findElement('.' + View.classes['signInWrapper'] + ' .id4-cta-register')[0], self);
                }
            },

            'setSignedInChecker': function() {
                var self = this,
                    timer = setInterval(function() {
                        if (self.item.controller.isSignedIn()) {
                            self.item.controller.toggleFavourite();
                            clearInterval(timer);
                        }
                    }, 1000);
            },

            'mouseEnter': function() {
                if (DOM.hasClass(this.item['button'], View.classes['leave'])) {
                    DOM.removeClass(this.item['button'], View.classes['leave']);
                }

                if (DOM.hasClass(this.item['button'], View.classes['refocus'])) {
                    DOM.removeClass(this.item['button'], View.classes['refocus']);
                }
                DOM.addClass(this.item['button'], View.classes['hover']);
            },

            'mouseLeave': function() {
                if (DOM.hasClass(this.item['button'], View.classes['hover'])) {
                    DOM.removeClass(this.item['button'], View.classes['hover']);
                }
                DOM.addClass(this.item['button'], View.classes['leave']);
                DOM.blur(this.item['button']);
            },

            'touchstart': function() { // These events can be used for mobile devices, both run 300 miliseconds prior to the click event.
            },

            'touchend': function(e) { // These events can be used for mobile devices, both run 300 miliseconds prior to the click event.
                var self = this,
                    userAgent;
                DOM.addClass(this.item['button'], View.classes['touchend']);
            },

            'confirmAction': function() {
                DOM.removeClass(this.item['management-panel'], View.classes['active']);
                DOM.show(this.item['button']);
                this.item.controller.toggleFavourite();
            },

            'cancelAction': function() {
                DOM.removeClass(this.item['management-panel'], View.classes['active']);
                DOM.show(this.item['button']);
                this.item.controller.keepFavourite();
            },

            'addFeedbackAction': function() {
                if(this.item.controller.isSignedIn()) {
                    this.item.controller.addFeedback();
                } else {
                    Upsell.renderUpsellDialog(this.item);
                }
            },

            'removeFeedbackAction': function() {
                if(this.item.controller.isSignedIn()) {
                    this.item.controller.removeFeedback();
                } else {
                    Upsell.renderUpsellDialog(this.item);
                }
            },

            'toggleOptionsPanel': function() {
                if (DOM.hasClass(this.item['options-panel'], View.classes['active'])) {
                    this.hideOptionsPanel();
                } else {
                    this.showOptionsPanel();
                }
            },

            'hideOptionsPanel': function() {
                var optionsButton = DOM.findElement('.' + View.classes['optionsButton'], this.item['element'])[0];
                DOM.removeClass(this.item['options-panel'], View.classes['active']);
                DOM.removeClass(optionsButton, View.classes['active']);
                DOM.removeClass(this.item['element'], View.classes['toFront']);
                DOM.addClass(this.item['feedback-overlay'], View.classes['hide']);
            },

            'showOptionsPanel': function() {
                this.item.controller.publish('feedbackMode.more', this.item );
                var optionsButton = DOM.findElement('.' + View.classes['optionsButton'], this.item['element'])[0];
                DOM.addClass(this.item['options-panel'], View.classes['active']);
                DOM.addClass(optionsButton, View.classes['active']);
                DOM.addClass(this.item['element'], View.classes['toFront']);
                DOM.removeClass(this.item['feedback-overlay'], View.classes['hide']);
            },

            'getLabelHTML': function(textLabel, variant) {
                variant = (variant == 'small') ? 'standard' : variant;

                textLabel = getLocalisedString(this.item['localisationString'], textLabel, variant, this.item.lang);

                if (/\{\{title\}\}/.test(textLabel)) textLabel = textLabel.replace(/\{\{title\}\} /, '<span class="' + View.classes['hidden'] + '">"' + this.item['title'].replace(/["']/g, "") + '"</span>');

                return textLabel;
            },

            'getLabelText': function(textLabel) {
                textLabel = getLocalisedString(this.item['localisationString'], textLabel, 'standard', this.item.lang);

                if (/\{\{title\}\}/.test(textLabel) && typeof(this.item['title'].replace) === 'function') {
                    textLabel = textLabel.replace(/\{\{title\}\}/, '"' + this.item['title'].replace(/["']/g, "").replace(/[\|][\|]/g, "-") + '"');
                }

                return textLabel;
            },

            'setLabel': function(elem, textKey, variant, html) {
                if (html) {
                    DOM.setHTML(elem, this.getLabelHTML(textKey, variant));
                } else {
                    DOM.setText(elem, this.getLabelText(textKey));
                }
            },

            'addClasses': function(classMap) {
                for (var i in classMap) {
                    DOM.addClass(this.item['button'], classMap[i]);
                }
            },

            'removeClasses': function(classMap) {
                for (var i in classMap) {
                    DOM.removeClass(this.item['button'], classMap[i]);
                }
            },

            'isButtonVisible': function(id) {
                var eVisible = false;
                var elem = document.getElementById(id);

                if (elem && elem != null && elem != undefined && elem.getBoundingClientRect != undefined) {
                    var rect = elem.getBoundingClientRect();
                }

                if (rect === undefined || rect.length == 0) {
                    return eVisible;
                } else if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
                    eVisible = true;
                }

                return eVisible;
            },

            'getConfirmationImageUrl': function() {
                if (this.item.item.hasOwnProperty('imageTemplateUrl') && this.item.item.imageTemplateUrl) {
                    var confirmationProperties = this.getConfirmationProperties();
                    if (confirmationProperties.hasOwnProperty('imageRecipe')) {
                        return this.item.item.imageTemplateUrl.replace('$recipe', confirmationProperties.imageRecipe);
                    }
                }

                return null;
            },

            'resetConfirmationImage': function(imageElement) {
                var defaultImageSrc = DOM.getAttr(imageElement, 'data-default-src');
                DOM.setAttr(imageElement, 'src', defaultImageSrc);
            },

            'setConfirmationImageOrIcon': function() {
                this.itemImageElement = DOM.findElement('.' + View.classes.itemImage);
                this.itemIconElement = DOM.findElement('.' + View.classes.itemMusicIcon);

                this.resetConfirmationImage(this.itemImageElement);

                var imageUrl = this.getConfirmationImageUrl();
                if (imageUrl) {
                    DOM.setAttr(this.itemImageElement, 'src', imageUrl);
                    DOM.addClass(this.itemIconElement, 'p-f-hide');
                    DOM.removeClass(this.itemImageElement, 'p-f-hide');
                } else {
                    DOM.addClass(this.itemImageElement, 'p-f-hide');
                    DOM.removeClass(this.itemIconElement, 'p-f-hide');
                }
            },

            'populateConfirmationDetails': function() {
                this.setConfirmationImageOrIcon();

                if (this.item.profile === 'playlister' || this.item.profile === 'track') {
                    this.populateTrackConfirmationDetails();
                } else {
                    this.populateItemConfirmationDetails();
                }
                this.setConfirmationLink();
            },

            'populateTrackConfirmationDetails': function() {
                this.trackNameElement = DOM.findElement('.' + View.classes.itemName);
                this.trackNameWrapperElement = DOM.findElement('.' + View.classes.itemNameWrapper);
                this.moreFromArtistElement = DOM.findElement('.' + View.classes.moreFromArtist);
                this.artistNameElement = DOM.findElement('.' + View.classes.artistName);
                DOM.removeClass(this.moreFromArtistElement, 'p-f-hide');
                DOM.removeClass(this.trackNameWrapperElement, 'p-f-hide');

                var trackName = this.item.item.trackName;
                var artistGid = this.item.item.artistGid;
                var artistName = this.item.item.artistName;

                if (trackName) {
                    DOM.setText(this.trackNameElement, trackName);
                } else {
                    DOM.addClass(this.trackNameWrapperElement, 'p-f-hide');
                }

                if (artistGid && artistName) {
                    DOM.setText(this.artistNameElement, artistName);
                    DOM.setAttr(this.artistNameElement, 'href', "http://www.bbc.co.uk/music/artists/" + artistGid);
                } else {
                    DOM.addClass(this.moreFromArtistElement, 'p-f-hide');
                }
            },

            'populateItemConfirmationDetails': function() {
                this.itemNameElement = DOM.findElement('.' + View.classes.itemName);
                this.itemNameWrapperElement = DOM.findElement('.' + View.classes.itemNameWrapper);

                var itemName = this.item.item.title;
                if (itemName) {
                    DOM.setText(this.itemNameElement, itemName);
                    DOM.removeClass(this.itemNameWrapperElement, 'p-f-hide');
                } else {
                    DOM.addClass(this.itemNameWrapperElement, 'p-f-hide');
                }

                DOM.addClass(DOM.findElement('.' + View.classes.moreFromArtist), 'p-f-hide');
            },

            'getConfirmationProperties': function() {
                // TODO MUSICCAT-2053: Remove this flagpole once transition is complete
                if (this.item.profile === 'radio' && !this.item.item.flagpoleRadioProfileConfirmation) {
                    return null;
                }

                if (confirmationProfiles.hasOwnProperty(this.item.profile)) {
                    var profileProperties = confirmationProfiles[this.item.profile];

                    if (profileProperties.hasOwnProperty(this.item.item.clipFormat)) {
                        return profileProperties[this.item.item.clipFormat];
                    } else if (profileProperties.hasOwnProperty(this.item.item.type)) {
                        return profileProperties[this.item.item.type];
                    } else {
                        return profileProperties['default'];
                    }
                }

                return null;
            },

            'setConfirmationLink': function() {
                var confirmationProperties = this.getConfirmationProperties();
                if (this.confirmationLinkElement) {
                    DOM.setText(this.confirmationLinkElement, confirmationProperties.text);
                    DOM.setAttr(this.confirmationLinkElement, 'href', confirmationProperties.url);
                }
            },

            'showAddedConfirmation': function() {
                this.confirmationDialogElement = DOM.findElement('.' + View.classes.confirmation);
                this.confirmationLinkElement = DOM.findElement('.' + View.classes.confirmAddedLink);
                this.moreFromArtistElement = DOM.findElement('.' + View.classes.moreFromArtist);

                this.openLinkInNewWindow(this.confirmationDialogElement);

                // Only show the dialog if confirmation is enabled and a supported profile is being used
                if (this.confirmationDialogElement && this.confirmationDialogElement.length > 0
                    && this.getConfirmationProperties()) {

                    // If the confirmation dialog is already visible for this item, do not update it but restart the fade timer
                    var confirmationDialogIsVisible = !DOM.hasClass(this.confirmationDialogElement, 'p-f-fade');
                    var confirmationDialogItemId = DOM.getData(this.confirmationDialogElement,'itemId');
                    if (confirmationDialogIsVisible && confirmationDialogItemId === this.item.item.id && !this.item.item.trackName) {
                        this.fadeConfirmationMessage(this.confirmationDialogElement, 4);
                        return;
                    }

                    // Set item ID on dialog element
                    DOM.setData(this.confirmationDialogElement, 'itemId', this.item.item.id);

                    // Bind events
                    if (this.confirmationEventsBound === false) {
                        this.bind('mouseover', this.confirmationMouseEnter, this.confirmationDialogElement[0], this);
                        this.bind('mouseout', this.confirmationMouseLeave, this.confirmationDialogElement[0], this);
                        this.bind('click', this.reportConfirmationLinkClick, this.confirmationLinkElement[0], this);
                        this.bind('click', this.reportMoreFromArtistLinkClick, this.moreFromArtistElement[0], this);

                        this.confirmationEventsBound = true;
                    }

                    // Add touch-specific styling
                    if ('ontouchstart' in document.documentElement) {
                        DOM.addClass(this.confirmationDialogElement, 'p-f-touch');
                    }

                    // Add item-specific content
                    this.populateConfirmationDetails();

                    // Translate confirmation text
                    this.updateAddedConfirmationTranslations(this.getAddedConfirmationTranslations(this.item.lang));

                    // Show dialog
                    DOM.removeClass(this.confirmationDialogElement, 'p-f-fade');
                    DOM.removeClass(this.confirmationDialogElement, 'p-f-hide');

                    // Focus on confirmation message
                    DOM.focus(this.confirmationDialogElement);

                    // Trigger timed fade
                    this.fadeConfirmationMessage(this.confirmationDialogElement, 4);
                }
            },

            'confirmationMouseEnter': function() {
                clearTimeout(window.musicFavouriteFadeConfirmationTimer);
                clearTimeout(window.musicFavouriteRemoveConfirmationTimer);

                DOM.removeClass(this.confirmationDialogElement, 'p-f-fade');
            },

            'confirmationMouseLeave': function() {
                this.fadeConfirmationMessage(this.confirmationDialogElement, 3);
            },

            'fadeConfirmationMessage': function(elem, secs) {
                var self = this;

                clearTimeout(window.musicFavouriteFadeConfirmationTimer);

                window.musicFavouriteFadeConfirmationTimer = setTimeout(function() {
                    DOM.addClass(elem, 'p-f-fade');
                    self.confirmationDismissed(self.item['button']);
                }, 1000 * secs);

                clearTimeout(window.musicFavouriteRemoveConfirmationTimer);

                window.musicFavouriteRemoveConfirmationTimer = setTimeout(function() {
                    DOM.addClass(elem, 'p-f-hide');
                }, 3000 + (1000 * secs));
            },

            'setProperTabIndexOnDialog': function() {
                // Make the close button on the upsell dialog tab-able.
                DOM.setAttr(DOM.findElement('.' + View.classes.closeDialogButton), 'tabindex', '5');
            },

            'getManagementPanelTranslations': function(lang) {
                var confirm = Localisation.getLocalisedString(this.item['localisationStringManagement'], 'confirm', 'management', lang),
                    cancel = Localisation.getLocalisedString(this.item['localisationStringManagement'], 'cancel', 'management', lang),
                    label = Localisation.getLocalisedString(this.item['localisationStringManagement'], 'remove', 'management', lang);

                return {
                    'confirmActionText': confirm,
                    'cancelActionText': cancel,
                    'actionLabelText': label
                };
            },

            'getAddedConfirmationTranslations': function(lang) {
                var confirmAddedText = Localisation.getLocalisedString(this.item['localisationStringConfirmation'], 'added', 'confirmation', lang),
                    confirmAddedLink = Localisation.getLocalisedString(this.item['localisationStringConfirmation'], 'link', 'confirmation', lang),
                    confirmAddedAfterLink = Localisation.getLocalisedString(this.item['localisationStringConfirmation'], 'afterLink', 'confirmation', lang);

                return {
                    'confirmAddedText': confirmAddedText,
                    'confirmAddedLink': confirmAddedLink,
                    'confirmAddedAfterLink': confirmAddedAfterLink
                };
            },

            'updateAddedConfirmationTranslations': function(translations) {
                DOM.setHTML(DOM.findElement('.' + View.classes.confirmAddedText), translations.confirmAddedText);
                DOM.setHTML(DOM.findElement('.' + View.classes.confirmAddedLink), translations.confirmAddedLink);
                DOM.setHTML(DOM.findElement('.' + View.classes.confirmAddedAfterLink), translations.confirmAddedAfterLink);
            },

            'reportConfirmationLinkClick': function() {
                var actionType = 'click';
                var actionName = 'favourites-confirmation-bar';
                var labels = this.getIstatsLabels();

                Stats.log(actionType, actionName, labels);

                return false;
            },

            'reportMoreFromArtistLinkClick': function() {
                var actionType = 'click';
                var actionName = 'favourites-confirmation-bar-more';
                var labels = this.getIstatsLabels();
                Stats.log(actionType, actionName, labels);

                return false;
            },

            'getIstatsLabels': function() {
                var passedOptions = this.item.item || {};
                var labels = {
                    favourites_type: passedOptions["type"] || 'unknown',
                    favourites_id: passedOptions["id"] || 'unknown'
                };
                if (passedOptions.hasOwnProperty("contextType") && passedOptions["contextType"] === 'music_home') {
                    labels['page_section'] = 'add-confirmation-bar';
                }
                return labels;
            },

            'openLinkInNewWindow': function(confirmationDialogElement) {
                var openInNewWindow = DOM.getAttr(this.item['element'], 'data-openinnewwindow');
                var links = DOM.findElement('a', confirmationDialogElement);

                for (var i in links) {
                    if (typeof(links[i]) == 'object') { //fixes PSP-3791
                        if (!!openInNewWindow) {
                            DOM.setAttr(links[i], 'target', '_blank');
                        } else {
                            DOM.setAttr(links[i], 'target', '_self');
                        }
                    }
                }
            }
        };

        View.classes = {
            'button': 'p-f-button',
            'text': 'p-f-text',
            'label': 'p-f-label',
            'label-display': 'p-f-label-display',
            'label-text': 'p-f-label-text',
            'label-action': 'p-f-label-action',
            'hide': 'p-f-hide',
            'hidden': 'p-f-hidden',
            'verb': 'p-f-verb',
            'active': 'p-f-active',
            'focus': 'p-f-focus',
            'busy': 'p-f-busy',
            'hover': 'p-f-hover',
            'added': 'p-f-added',
            'remove': 'p-f-remove',
            'removed': 'p-f-removed',
            'just-added': 'p-f-just-added',
            'error': 'p-f-error',
            'refocus': 'p-f-refocus',
            'leave': 'p-f-leave',
            'no-blur': 'p-f-noblur',
            'touchstart': 'p-f-touchs',
            'touchend': 'p-f-touche',
            'signInWrapper': 'pre-signin-wrapper',
            'closeDialogButton': 'p-f-dialog-close',
            'confirmation': 'p-f-confirmation',
            'confirmAddedText': 'p-f-added-text',
            'confirmAddedLink': 'p-f-added-link',
            'confirmAddedAfterLink': 'p-f-added-after-link',
            'itemImage': 'p-f-item-image',
            'itemMusicIcon': 'p-f-item-music-icon',
            'itemName': 'p-f-item-name',
            'itemNameWrapper': 'p-f-item-name-wrapper',
            'artistName': 'p-f-artist-name',
            'moreFromArtist': 'p-f-more-from-artist-text',
            'management-panel': 'p-f-management-panel',
            'confirmActionButton': 'p-f-management-panel-button.confirm',
            'cancelActionButton': 'p-f-management-panel-button.cancel',
            'managementPanelLabel': 'p-f-management-panel-label-text',
            'actionButtonLabel': 'p-f-management-panel-button-text',
            'options-panel': 'p-f-options-panel',
            'feedback-overlay': 'p-f-feedback-added-overlay',
            'feedbackButton': 'p-f-feedback-button',
            'optionsButton': 'p-f-options-button',
            'undoButton': 'p-f-undo-feedback',
            'toFront': 'p-f-to-front'
        };

        return View;
    }
);
